<template>
    <div>
        <Header title="SDK Manager" icon="Webhook" />
        <div class="grid grid-cols-2 gap-4">
        <div><WhiteBox v-if="!loading">
            <template v-slot:content>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.backgroundColour" title="Choose your color">
                    <p>Background Colour</p>
                </div>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.cardBackgroundColour" title="Choose your color">
                    <p>Card Background Colour</p>
                </div>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.cardBorderColour" title="Choose your color">
                    <p>Card Border Colour</p>
                </div>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.primaryTextColour" title="Choose your color">
                    <p>Primary Font Colour</p>
                </div>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.secondaryTextColour" title="Choose your color">
                    <p>Secondary Font Colour</p>
                </div>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.primaryButtonBackground" title="Choose your color">
                    <p>Primary Button Colour</p>
                </div>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.primaryButtonBorder" title="Choose your color">
                    <p>Primary Button Border Colour</p>
                </div>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.primaryButtonTextColour" title="Choose your color">
                    <p>Primary Button Text Colour</p>
                </div>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.secondaryButtonBackground" title="Choose your color">
                    <p>Secondary Button Colour</p>
                </div>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.secondaryButtonBorder" title="Choose your color">
                    <p>Secondary Button Border Colour</p>
                </div>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.secondaryButtonTextColour" title="Choose your color">
                    <p>Secondary Button Text Colour</p>
                </div>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.dividerColour" title="Choose your color">
                    <p>Divider Colour</p>
                </div>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.highlightTextColour" title="Choose your color">
                    <p>Highlight Text Colour</p>
                </div>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.sectionLabelTitleColour" title="Choose your color">
                    <p>Section Label Title Text Colour</p>
                </div>
                <div class="flex justify-start gap-x-2 items-center">
                    <input type="color"
                        class="p-1 h-10 w-14 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
                        id="hs-color-input" v-model="sdkColours.sectionLabelSubTitleColour" title="Choose your color">
                    <p>Section Label Subtitle Text Colour</p>
                </div>
                <div class="justify-end flex gap-x-2">
                    <CustomButton @click="updateColoursSDK" text="Save"></CustomButton>
                    <CustomButton type="navigate" @click="$router.push('/sdk-preview')" text="Preview"></CustomButton>

                </div>
            </template>
        </WhiteBox></div>
        <div style="zoom: 75%" class="mt-5 text-lg mb-5">
    <div class="iphone-outer-frame mx-auto">
      <div class="iphone-inner-frame">
        <div class="iphone-notch"></div>
        <div :key="componentKey" :style="`background-color:${sdkColours.backgroundColour}; color:${sdkColours.primaryTextColour} `" class="screen-content">
          <div id="offerSDKHolder" class="w-full "></div>
        </div>

      </div>
    </div>
  </div>
    </div>
    </div>
</template>
<script>
import Header from '@/components/Header.vue';
import WhiteBox from '@/components/WhiteBox.vue';
import CustomButton from '@/components/inputs/CustomButton.vue';
import BoogiSDK from 'boogi-javascript-sdk'


export default {
    name: "manage-sdk",
    components: {
        Header,
        WhiteBox,
        CustomButton
    },
    data() {
        return {
            loading:false,
            componentKey: 0,

            sdkColours:{
                sectionLabelTitleColour:"#F6F6F6",
                sectionLabelSubTitleColour:"#B3B5B9",
                primaryTextColour:"#F6F6F6",
                secondaryTextColour:"#B3B5B9",
                highlightTextColour:"#73f46c",
                cardBackgroundColour:"#000814",
                cardBorderColour:"#000814",
                dividerColour:"#333943",
                primaryButtonBackground:"#fcbc2c",
                primaryButtonBorder:"#fcbc2c",
                primaryButtonTextColour:"#19212B",
                secondaryButtonBackground:"#323943",
                secondaryButtonBorder:"#323943",
                secondaryButtonTextColour:"#CAD5E6",
                backgroundColour:"#19212B"
            }
        }
    },
    created(){
        this.getColoursSDK()
        this.fetchIdFromAPI()
    },
    methods: {

        async fetchIdFromAPI() {
            const token = localStorage.getItem('token')
            const api  = localStorage.getItem('apiType')
        try {
            const response = await fetch(`https://${api}.boogi.io/private/api/client/api-key/sdk/token`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`
                }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch ID from API');
            }
            const data = await response.json();
            const boogiSDK = new BoogiSDK();
            boogiSDK.displayOffers(data.token, api, 'offerSDKHolder',{height: '100%'});
        } catch (error) {
            console.error('Error fetching ID from API:', error);
            throw error;
        }
    },

        async getColoursSDK() {
        try {
            const token = localStorage.getItem('token')
            const api  = localStorage.getItem('apiType')

            this.loading = true;
            const response = await fetch(`https://${api}.boogi.io/private/api/client/sdk`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `${token}`,
                },
            });

            if (response.ok) {
                var object = await response.json();
                this.sdkColours = object;
                delete this.sdkColours.createdOn
                delete this.sdkColours.id
                delete this.sdkColours.updatedOn
                delete this.sdkColours.publisherId
                
                this.loading = false
                this.fetchIdFromAPI()

            }
        } catch (error) {
            console.error(error);
        }
    },
    async updateColoursSDK() {
        try {
            const token = localStorage.getItem('token')
            const api  = localStorage.getItem('apiType')

            console.log(this.sdkColours)

            this.loading = true;
            const response = await fetch(`https://${api}.boogi.io/private/api/client/sdk`, {
                method: "POST",
                body: JSON.stringify(this.sdkColours),
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `${token}`,
                },
            });

            if (response.ok) {
                var object = await response.json();
                this.sdkColours = object;
                delete this.sdkColours.createdOn
                delete this.sdkColours.id
                delete this.sdkColours.updatedOn
                delete this.sdkColours.publisherId
                this.loading = false
                this.componentKey +=1;
                this.fetchIdFromAPI()
                // localStorage.setItem('colours',object)
                // this.getOfferById(this.individualRetailer.programOffers[0].id);
            }
        } catch (error) {
            console.error(error);
        }
    },

    }
}
</script>
<style scoped>
.iphone-outer-frame {
    width: 400px;
    height: 850px;
    border-radius: 50px;
    background: linear-gradient(145deg, #444, #222);
    /* padding: 10px; */
    display: flex;
    padding: 10px;
    justify-content: center;
    align-items: center;
    /* box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.3); */
  }

  /* Inner iPhone Frame */
  .iphone-inner-frame {
    width: 375px;
    height: 850px;
    border-radius: 40px;
    height: 812px;
    position: relative;
    overflow: hidden;
    align-items: center;
  }

  /* iPhone Notch */
  .iphone-notch {
    width: 210px;
    height: 30px;
    background: #000;
    border-radius: 0 0 20px 20px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  /* Header */
  .header {
    width: 100%;
    background-color: #fff;
    padding: 15px 20px;
    text-align: center;
    margin-top: 20px;
    font-size: 20px;
    font-weight: bold;
  }

  /* Screen Content */
  .screen-content {
  width: 100%;
  background-color: white;
  border-radius: 30px 30px 0 0; /* Rounded top corners only */
  margin-top: 10px; /* Adjust for spacing */

  align-items: center;
  height:100%;
}

  /* Inner Content */
  #offerSDKHolder {
    max-width: 500px;
    height: 100%;
    width: 100%;
    margin: 0 auto;
  }
  iframe{
    height: 100%;
  }

  /* Footer Nav */
 
</style>